import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-570e6870"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wysiwyg-editor" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "B", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "i", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("s", null, "S", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bubble_menu = _resolveComponent("bubble-menu")!
  const _component_editor_content = _resolveComponent("editor-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.editor)
      ? (_openBlock(), _createBlock(_component_bubble_menu, {
          key: 0,
          class: "block-text-menu",
          editor: _ctx.editor,
          "tippy-options": { duration: 100 }
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["option", { 'is-active': _ctx.editor.isActive('heading', { level: 1 }) }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editor.chain().focus().toggleHeading({ level: 1 }).run()))
            }, " H1 ", 2),
            _createElementVNode("span", {
              class: _normalizeClass(["option", { 'is-active': _ctx.editor.isActive('heading', { level: 2 }) }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editor.chain().focus().toggleHeading({ level: 2 }).run()))
            }, " H2 ", 2),
            _createElementVNode("span", {
              class: _normalizeClass(["option", { 'is-active': _ctx.editor.isActive('heading', { level: 3 }) }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editor.chain().focus().toggleHeading({ level: 3 }).run()))
            }, " H3 ", 2),
            _createElementVNode("span", {
              class: _normalizeClass(["option", { 'is-active': _ctx.editor.isActive('bold'), 'disabled': _ctx.editor.isActive('heading') }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editor.isActive('heading') ? null : _ctx.editor.chain().focus().toggleBold().run()))
            }, _hoisted_3, 2),
            _createElementVNode("span", {
              class: _normalizeClass(["option", { 'is-active': _ctx.editor.isActive('italic') }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editor.chain().focus().toggleItalic().run()))
            }, _hoisted_5, 2),
            _createElementVNode("span", {
              class: _normalizeClass(["option", { 'is-active': _ctx.editor.isActive('strike') }]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editor.chain().focus().toggleStrike().run()))
            }, _hoisted_7, 2),
            _createElementVNode("span", {
              class: _normalizeClass(["option", { 'is-active': _ctx.editor.isActive('bulletList') }]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editor.chain().focus().toggleBulletList().run()))
            }, " • ", 2),
            _createElementVNode("span", {
              class: _normalizeClass(["option", { 'is-active': _ctx.editor.isActive('link') }])
            }, " Link ", 2)
          ]),
          _: 1
        }, 8, ["editor"]))
      : _createCommentVNode("", true),
    _createVNode(_component_editor_content, {
      editor: _ctx.editor,
      spellcheck: "false",
      onKeydownCapture: _withKeys(_ctx.preventEnter, ["enter"])
    }, null, 8, ["editor", "onKeydownCapture"])
  ]))
}